import React from 'react';

import BlockAccessPage from '../../../../../components/BlockAccess/BlockAccessPage';
import {checkIfHasPermissions} from '../../../../../components/Menu/Utils/commonFunctions';
import NonRenewableTable from '../../../../../components/Table/NonRenewable';
import RenewableTable from '../../../../../components/Table/Renewable';
import Tabs from '../../../../../components/Tabs/Tabs';
import {PermissionEnum} from '../../../../../constants/permissionsEnum';
import TranslatedText from '../../../../../libraries/I18N/TranslatedText';
import {accessModule} from '../../../../../store/companyStore/companyDetailsStore';
import {shouldBlockModuleAccess} from '../../../../../utils/SubscriptionHelper';
// import {IFacilityDetail} from '../interface/commonI';

const Electricity: React.FC<{
  selectedYear: string;
  facilityId: string;
  // facilityDetail: IFacilityDetail;
}> = ({
  facilityId,
  selectedYear
  // facilityDetail
}) => {
  const ElectricityTab = [
    {
      id: 'renewable',
      name: <TranslatedText translationKey="Renewable" />,
      component: shouldBlockModuleAccess(accessModule.scope2) ? (
        <BlockAccessPage />
      ) : (
        <RenewableTable facilityId={facilityId} selectedYear={selectedYear} />
      ),
      hidden: !checkIfHasPermissions(
        PermissionEnum.OrgManagerRenewableElectricity
      )
    },
    {
      id: 'nonRenewable',
      name: <TranslatedText translationKey="Non Renewable" />,
      component: shouldBlockModuleAccess(accessModule.scope2) ? (
        <BlockAccessPage />
      ) : (
        <NonRenewableTable
          facilityId={facilityId}
          selectedYear={selectedYear}
          // facilityDetail={facilityDetail}
        />
      ),
      hidden: !checkIfHasPermissions(
        PermissionEnum.OrgManagerNonRenewableElectricity
      )
    }
  ].filter((item) => !item.hidden);

  return <Tabs array={ElectricityTab} type="card" />;
};

export default Electricity;
